import React  from 'react';
import styles from '../styles/Login.module.css';

const RegisterUser = () => {

  return (
    <div className={styles.LoginUser}>
        <div className={styles.InLogin}>
            <div className={styles.Form}>
                <p>Registracija začasno odstranjena</p>
            </div>
        </div>
    </div>
  );
}
  
export default RegisterUser;